import { HelpOutlineOutlined } from '@mui/icons-material'
import { Avatar, Typography } from '@mui/material'
import MyTagsLogo from 'components/svg-assets/MyTagsLogo'
import React from 'react'
import styles from './AuthPageTestimonial.module.scss'

const testimonialContents = [
  {
    name: 'Evie-Rose Dawson',
    img: 'https://i.pravatar.cc/150?img=35',
    content: <span>"I can't say enough about MyTags. I don't always clop, but when I do, it's because of MyTags. I am really satisfied with my MyTags."</span>
  },
  {
    name: 'Leonard Plant',
    img: 'https://i.pravatar.cc/150?img=13',
    content: <span>"MyTags saved my business. I love your system. I STRONGLY recommend MyTags to EVERYONE interested in running a successful online business!"</span>
  },
  {
    name: 'Petra Spence',
    img: 'https://i.pravatar.cc/150?img=5',
    content: <span>"Very easy to use. I wish I would have thought of it first. I would be lost without MyTags. Thank you for making it painless, pleasant and most of all hassle free!"</span>
  },
]

export default function AuthPageTestimonial () {

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = React.useState(undefined);

  React.useEffect(() => {
    setCurrentTestimonialIndex((Math.floor(Math.random()*testimonialContents.length)));
  }, [])

  if (currentTestimonialIndex === undefined) {
    return (
      <div></div>
    )
  }

  return (
    <div>
      <div className={styles.logoIcon}>
        <MyTagsLogo
          iconOnly
          accentColor='#110D0F'
          baseColor='#ffffff'
          dotsTopLeft={false}
          dotsTopRight={false}
          dotsBottomRight={false}
        />
      </div>
      <div className={styles.testimonial}>
        <div className={styles.iconWrapper}>
          <Avatar
            sx={{ width: 56, height: 56 }}
            alt={testimonialContents[currentTestimonialIndex].name}
            src={testimonialContents[currentTestimonialIndex].img}
          />
        </div>
        <div className={styles.testimonialContent}>
          <Typography variant='h2' sx={{ mb: 3 }}>
            Our customers experience:
          </Typography>
          <Typography variant='body1' fontSize='large' color='common.white'>
            {testimonialContents[currentTestimonialIndex].content}
          </Typography>
          <Typography variant='subtitle1' color='common.white' sx={{ mt: 2 }}>
            {testimonialContents[currentTestimonialIndex].name}
          </Typography>
          <Typography
            variant='body1'
            fontSize='large'
            sx={{ mt: 3, cursor: 'pointer' }}
            onClick={() => setCurrentTestimonialIndex((Math.floor(Math.random()*testimonialContents.length)))}
          >
            <u><strong>Another testimonial</strong></u>
          </Typography>
        </div>
      </div>
    </div>
  )
}